function replacePlaceholders(ids, data) {
    ids.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
            if (element.innerHTML) {
                element.innerHTML = element.innerHTML.replace(/{{js-(.*?)}}/g, (_, key) => data[key]);
            }
            if (element.hasAttribute('data-src')) {
                const dataSrc = element.getAttribute('data-src');
                const newSrc = dataSrc.replace(/{{js-(.*?)}}/g, (_, key) => data[key].toUpperCase());
                element.setAttribute('src', newSrc);
                element.removeAttribute('data-src');
            }
        }
    });
}

function disableGeoLocationBanner() {
    Array.from(document.getElementsByClassName('bel-geoLocationBanner')).forEach((e) => e.innerHTML = '');
}

async function fetchData() {
    try {
        const response = await fetch(`${countryCode}/shop/${analyticsJson.metadata.pageLocale}/geo/country`, {
            headers: new Headers({ 'x-belimo-location-pathname': location.pathname }),
        });

        if (!response.ok) {
            throw new Error('Network answer was not okay.');
        }

        const data = await response.json();
        const banner = document.getElementById('geoLocationBanner');
        const overlay = document.getElementById('geoLocationBannerOverlay');

        if(data.hasOwnProperty('geoRequestMatch') && !data.geoRequestMatch){

            if (window.location.href.includes('iw_IL')) {
                const elements = document.querySelectorAll('.bel-glb_button-flag');

                elements.forEach((e) => {
                    e.style.margin = '0 0 0 1rem';
                });
            }

            const stayButton = document.getElementById('stayButton');
            const switchButton = document.getElementById('switchButton');
            const closeButton = document.getElementById('closeButton');

            replacePlaceholders(['glb_headline', 'glb_text', 'glb_img_current', 'glb_img_correct', 'glb_span_current', 'glb_span_correct'], data);

            banner.style.display = 'block';
            overlay.style.display = 'block';

            // Trigger the slide-down animation
            setTimeout(() => {
                banner.classList.add('show');
                overlay.classList.add('show');
            }, 100);

            function hideBannerAndOverlay() {
                banner.classList.remove('show');
                overlay.classList.remove('show');
                overlay.style.display = 'none';
                setTimeout(() => {
                    banner.style.display = 'none';
                }, 500);
            }

            function buildWebsiteSwitchURL(countryCode, languageCode) {
                // a path without leading and trailing slashes
                const path = `${window.location.pathname}`.replace(/^\/+|\/+$/g, '');
                const pathParts = path.split('/');
                if(path.includes('/shop/')) {
                    pathParts.splice(0, 1, countryCode);
                    pathParts.splice(2, 1, languageCode);
                } else {
                    pathParts.splice(0, 1, countryCode);
                    pathParts.splice(1, 1, languageCode);
                }
                return `${window.location.origin}/${pathParts.join('/')}`;
            }

            async function checkWebsiteSwitchURL(url) {
                try {
                    const response = await fetch(url);
                    return response.ok;
                } catch (error) {
                    console.error(`Error checking URL ${url}:`, error);
                    return false;
                }
            }

            stayButton.addEventListener('click', function () {
                sessionStorage.setItem('geoLocationState', 'stayed');
                hideBannerAndOverlay();
                console.log('User decided to stay!');
            });

            switchButton.addEventListener('click', function () {
                sessionStorage.setItem('geoLocationState', 'switched');
                hideBannerAndOverlay();
                console.log('User decided to switch!');
                const switchUrl = buildWebsiteSwitchURL(`${data.geoCountryCode.toLowerCase()}`, `${data.geoLanguageCode}`);
                checkWebsiteSwitchURL(switchUrl)
                .then((exists) => {
                    if (exists) {
                        window.location.href = switchUrl;
                    } else {
                        // fallback case: redirect to the homepage
                        window.location.href = `${window.location.origin}/${data.geoCountryCode.toLowerCase()}`;
                    }
                });
            });

            closeButton.addEventListener('click', function () {
                console.log('User closed Banner!');
                hideBannerAndOverlay();
            });
        }
        else {
            disableGeoLocationBanner();
        }
    } catch (error) {
        disableGeoLocationBanner();
        console.error('There was an error handling the geoLocation fetch request:', error);

    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (!sessionStorage.getItem('geoLocationState')) {
        fetchData();
    }
});
